import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line
export default function VerticalDotsIcon(props) {
    return (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: 512, height: 512 }, props, { children: _jsxs("g", Object.assign({ "data-name": "01 align center" }, { children: [_jsx("circle", { cx: 12, cy: 2, r: 2 }), _jsx("circle", { cx: 12, cy: 12, r: 2 }), _jsx("circle", { cx: 12, cy: 22, r: 2 })] })) })));
}
//# sourceMappingURL=VerticalDotsIcon.js.map